type OptionalStatsActionInput = {
  filter?: unknown | null
  highlight?: unknown | null
  space?: unknown | null
  time?: unknown | null
}

export function buildOptionalStatsActionInput(input: OptionalStatsActionInput) {
  return {
    ...(input.filter == null ? {} : { filter: input.filter }),
    ...(input.highlight == null ? {} : { highlight: input.highlight }),
    ...(input.space == null ? {} : { space: input.space }),
    ...(input.time == null ? {} : { time: input.time }),
  }
}
